
import {
  defineComponent,
  ref,
  computed,
  PropType,
  reactive,
} from 'vue';
import { updateVlaue } from '@/api/monitor-center-kt';
import type { IUpdateVlaue, IKeysPageListItem } from '@/api/monitor-center-kt/type.d';
import { ElMessage } from 'element-plus';
import JsonEditorVue from 'json-editor-vue3';

export default defineComponent({
  name: 'UpdateVlaue',
  emits: ['update:visible', 'handleOperateSuccess'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object as PropType<IKeysPageListItem>,
      required: true,
    },
  },
  components: { JsonEditorVue },
  setup(props, { emit }) {
    const selfVisible = computed({
      get() {
        return props.visible;
      },
      set(val: boolean) {
        emit('update:visible', val);
      },
    });

    const formRef = ref();

    // 转换json
    const jsonData = ref({});
    const formData = reactive<IUpdateVlaue>({
      key: '',
      value: '',
    });

    const handleClose = () => {
      selfVisible.value = false;
      formRef.value.resetFields();
    };

    const handleSave = async () => {
      if (JSON.stringify(jsonData.value) === '{}' || jsonData.value === '') {
        formData.value = '';
        await formRef.value.validate();
      } else {
        formData.value = JSON.stringify(jsonData.value);
      }
      await formRef.value.validate();
      await updateVlaue(formData);
      ElMessage.success('操作成功！');
      emit('handleOperateSuccess', {
        ...formData,
        ttl: props.data.ttl,
      });
      handleClose();
    };

    const handleOpen = () => {
      formData.key = props.data?.key;
      formData.value = props.data?.value;
      jsonData.value = formData.value ? JSON.parse(formData.value) : '';
    };

    return {
      formRef,
      formData,
      jsonData,
      selfVisible,
      rules: {
        value: [
          { required: true, message: '请输入value', trigger: 'blur' },
        ],
      },
      handleClose,
      handleSave,
      handleOpen,
    };
  },
});
